import React from 'react';
import ReactDOM from 'react-dom';
import UPshowState from '../UPshowState';
import StateFactory from '../StateFactory';
import LiveContent from './LiveContent';
import StateService from '../../services/StateService';
import AudioAnnouncementsService from '../../services/AudioAnnouncementsService';
import { setAuthCookies } from '../../libs/helpers';
import { getDeviceInfo } from '../../Upshow';
import SocketService from '../../services/SocketService';
import MetricsService from '../../services/MetricsService';
import { getSystemMetrics } from '@upshow/brightsign/src';

export default class LiveContentState extends UPshowState {

    get name () {
        return 'live_content';
    }

    playerError = false;

    onError = (error) => {
        console.log('Fatal player error', error.message);
        this.playerError = true;
        this.renderLiveContent();
    };

    solveError = (message) => {
        console.log('Fatal player error solved', message);
        this.playerError = false;
        this.renderLiveContent();
    };

    pauseLiveContent = () => {
        this.state.playing = false;
        this.stopRender();
    };

    playLiveContent = () => {
        this.state.playing = true;
        this.renderLiveContent();
    };

    stopRender () {
        ReactDOM.render(<></>, this.node);
    };

    renderLiveContent () {
        ReactDOM.render(
            <LiveContent
                {...this.state}
                playerError={this.playerError}
                done={() => { StateService.flagFinishedLiveContent(this.state.state.liveContent.id);}}
                error={this.onError}
                warning={(warning) => { 
                    console.error('warning', warning);
                }}
                onHeartbeat={async (data) => {
                    if (!MetricsService.isEnabled()) return;
                    
                    const deviceInfo = getDeviceInfo();
                    const system = deviceInfo.model === 'BrightSign' ? await getSystemMetrics() : null;
                    
                    const payload = {
                        type: 'heartbeat-metrics',
                        timestamp: new Date().toISOString(),
                        system,
                        player: data,
                        liveEvent: this.state.state.liveEvent
                    };
                    
                    SocketService.socket.emit('heartbeat-metrics', payload);
                }}
                solveError={this.solveError}
            />, this.node);
    }

    async preload () {
        const metadata = this.state.state.liveContent.metadata;
        
        if (metadata.isSecure && metadata.secureUrl) {
            const secureUrlLiveContent = new URL(metadata.secureUrl);
            secureUrlLiveContent.searchParams.set('liveEventId',this.state.state.liveContent.id);

            const { data } = await setAuthCookies(secureUrlLiveContent.toString());
            
            if (metadata.hasDrm) {
                console.log("save drm token");
                this.state.state.liveContent.token = data.signed;
            }
        }

        this.state.soundState.shouldSound = true;
        this.state.soundState.disableOverride = true;
        AudioAnnouncementsService.silence();

        this.renderLiveContent();
        return super.preload();
    }
}

StateFactory.register('live_content', LiveContentState, 10);
